import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc4da3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "biz-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "biz-card-title" }, "看脸统计", -1))
const _hoisted_4 = { class: "card-blobk" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "待看", -1))
const _hoisted_6 = { class: "card-num" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已看", -1))
const _hoisted_8 = { class: "card-num" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "全部", -1))
const _hoisted_10 = { class: "card-num" }
const _hoisted_11 = { class: "biz-card order-table" }
const _hoisted_12 = { class: "mini-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "近期看脸记录", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("全部看脸记录")
const _hoisted_15 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  style: {"margin-left":"20px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1637224104587",
  class: "icon",
  viewBox: "0 0 1041 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3351",
  width: "48",
  height: "48"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M135.714133 1024A122.1632 122.1632 0 0 1 13.653333 901.9392V122.0608A122.1632 122.1632 0 0 1 135.714133 0h779.8784A122.1632 122.1632 0 0 1 1037.653333 122.0608v779.8784A122.1632 122.1632 0 0 1 915.592533 1024H135.714133z m362.530134-300.8512L743.253333 974.813867h172.3392a72.9088 72.9088 0 0 0 72.874667-72.874667V638.685867L785.578667 435.797333 498.244267 723.1488zM62.839467 869.188267v32.768a72.9088 72.9088 0 0 0 72.874666 72.874666h539.204267L327.714133 631.125333 62.839467 869.205333z m72.874666-820.002134a72.9088 72.9088 0 0 0-72.874666 72.874667v677.5808L330.410667 555.434667l133.546666 133.546666L785.578667 360.823467 988.4672 567.125333V122.0608a72.9088 72.9088 0 0 0-72.874667-72.874667H135.714133z m130.013867 324.949334a122.1632 122.1632 0 0 1-122.0608-122.0608 122.1632 122.1632 0 0 1 122.0608-122.0608 122.1632 122.1632 0 0 1 122.043733 122.0608c0 67.328-54.818133 122.043733-122.043733 122.043733z m0-195.037867a72.9088 72.9088 0 0 0-72.874667 72.874667 72.9088 72.9088 0 0 0 72.874667 72.874666 72.9088 72.9088 0 0 0 72.874667-72.874666 72.9088 72.9088 0 0 0-72.874667-72.874667z",
    "p-id": "3352",
    fill: "#bfbfbf"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { style: {"font-weight":"600"} }
const _hoisted_21 = {
  key: 0,
  style: {"color":"rgb(82, 77, 77)","margin-left":"10px"}
}
const _hoisted_22 = { style: {"margin-right":"20px"} }
const _hoisted_23 = { style: {"margin-right":"20px"} }
const _hoisted_24 = { style: {"margin-right":"20px"} }
const _hoisted_25 = {
  key: 0,
  style: {"color":"#409eff"}
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("编辑报告")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("AI看脸")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("section", null, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.totalData.orderFinishnetWaitTotal), 1)
        ]),
        _createElementVNode("section", null, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.totalData.orderFinishedTotal), 1)
        ]),
        _createElementVNode("section", null, [
          _hoisted_9,
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.totalData.orderTotal), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("p", null, [
          _createVNode(_component_el_button, { onClick: _ctx.getRecord }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_el_table, { data: _ctx.orderList }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { width: "150" }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", null, _toDisplayString(scope.row.groupName), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.convertDate(scope.row.updatetime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { width: "180" }, {
            default: _withCtx((scope) => [
              (scope.row.faceImgName != null)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _createElementVNode("img", {
                      class: "img-block",
                      src: 
                  'https://dayu.meb.im/api/face/getOssImage?fileName=' +
                  scope.row.faceImgName[0] +
                  '&style=image/auto-orient,1/resize,m_lfit,w_70/quality,q_90'
                
                    }, null, 8, _hoisted_16)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_17, _hoisted_19))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { width: "300" }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(scope.row.name), 1),
                (scope.row.remark)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(" + _toDisplayString(scope.row.remark) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_22, "年龄：" + _toDisplayString(scope.row.age), 1),
                _createElementVNode("span", _hoisted_23, "身高：" + _toDisplayString(scope.row.height), 1),
                _createElementVNode("span", _hoisted_24, "体重：" + _toDisplayString(scope.row.weight), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, null, {
            default: _withCtx((scope) => [
              _createTextVNode(" 订单来源： " + _toDisplayString(scope.row.updateUserId == null || scope.row.updateUserId == ""
                ? "系统"
                : scope.row.updateUserId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, null, {
            default: _withCtx((scope) => [
              (scope.row.orderStatus == '正在看')
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, " 正在看脸中... "))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.exportPdf(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.editWorkbench(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "warning",
                  onClick: ($event: any) => (_ctx.editAIReporty(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ]))
}